export default "__VITE_ASSET__Z6rEiPI1__"